import React from "react";
import Image from "gatsby-image";

import {
  Container,
  Title,
  InnerContainer,
  Parag,
  AbsoluteContainer,
  Content,
} from "./Components";

const Paragraph = ({ title, columnOne, columnTwo, image, showImage }) => {
  const color = showImage ? 'white' : '#707070';
  return (
    <Container relative={showImage}>
      {showImage &&
        <Image
          style={{
            width: '100%',
            height: 'auto',
            minHeight: '550px',
            maxHeight: '550px',
          }}
          fluid={image.childImageSharp.fluid}
        />
      }
      <AbsoluteContainer absolute={showImage}>
        <Content>
          <Title>{title}</Title>
          <InnerContainer>
            <Parag color={color}>{columnOne}</Parag>
            <Parag color={color}>{columnTwo}</Parag>
          </InnerContainer>
        </Content>
      </AbsoluteContainer>
    </Container>
  );
};

export default Paragraph;
